import React from "react";
import WavyDivider from "./WavyDivider";
import { siteData } from "../mock";

const Praticienne = () => {
  return (
    <section id="praticienne" className="section praticienne">
      <div className="section-header">
        <WavyDivider />
        <h2 className="section-title">Votre praticienne</h2>
      </div>

      <div className="prat-inner">
        <div className="prat-photo">
          <img src={siteData.images.portrait} alt="Portrait Catherine SAC-EPEE" />
        </div>
        <div className="prat-text">
          <h3 className="prat-name">Catherine Sac-Epée</h3>
          <h4 className="prat-role">Praticienne en Zen Shiatsu</h4>
          <p>
            Après une carrière en entreprise — dont les <strong>20 dernières années en qualité de Commerciale dans le secteur hospitalier</strong> — j’ai entrepris une reconversion professionnelle guidée par l’envie d’accompagner les personnes avec une approche bienveillante.
          </p>
          <p>
            Mon intention est d’apporter du <strong>bien-être ou du mieux-être</strong> (physique, psychologique, émotionnel) à celles et ceux qui me consultent. Ma formation à l’école <strong>«&nbsp;Shiatsu Génération&nbsp;»</strong> (13) a duré 3 ans, et j’ai ouvert mon cabinet en <strong>2025</strong>.
          </p>
          <p>
            Considérant que la <strong>Santé et le Bien-être</strong> sont deux facteurs-clés de la performance au travail, je propose également mes services aux <strong>entreprises et collectivités</strong> dans le cadre de la QVCT.
          </p>
          <p className="prat-area">
            <strong>Interventions&nbsp;:</strong> La Ciotat, Aubagne, Aix, Marseille et Toulon.
          </p>
          <a href="#contact" className="btn btn-primary">PRENDRE UN RDV</a>
        </div>
      </div>
    </section>
  );
};

export default Praticienne;
